module.exports = __webpack_public_path__ + "img/ms-4.420f61dc.webp";